import { HeroSection } from "@/components/search-engine/HeroSection";
import { ConnectedRepositoriesSection } from "@/components/search-engine/ConnectedRepositoriesSection";
import { RepositoriesSection } from "@/components/search-engine/RepositoriesSection";

const SearchEngine = () => {
  return (
    <div className="bg-background">
      <HeroSection />
      <ConnectedRepositoriesSection />
      <RepositoriesSection />
    </div>
  );
};

export default SearchEngine;